import React from 'react'

const NumberInput = React.forwardRef((props, ref) => (
  <label className='league-label'>
    {props.label}
    <input className='league-control' {...props} min='0' step='1' type='number' ref={ref} />
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default NumberInput
